"use strict";
var _a;
import { stringifyValueForError } from "./value.js";
const IDENTIFYING_FIELD = Symbol.for("ConvexError");
export class ConvexError extends Error {
  constructor(data) {
    super(typeof data === "string" ? data : stringifyValueForError(data));
    this.name = "ConvexError";
    this[_a] = true;
    this.data = data;
  }
}
_a = IDENTIFYING_FIELD;
//# sourceMappingURL=errors.js.map
